import React from 'react';
import UI from '../ui';
import { onClickHandler } from '../ui/utilities/click_handler';
import { useNavigate } from 'react-router';
import PickIcon from './PickIcon';
import { post } from '../mocks/postsMocks/postsStore';
import { images_db } from './PostImage';

const PostsGrid: React.FC<{ posts: post[] }> = ({ posts }) => {
  const navigate = useNavigate();
  return (
    <UI.VerticalLayout overflow="scroll">
      <UI.Grid>
        {posts.map(post => (
          <React.Fragment key={post.id}>
            <div style={{ position: 'absolute', padding: '2px' }}>
              <UI.Chip
                content={(
                  <UI.HorizontalLayout gap={5} align="center">
                    {post.pick && <PickIcon size={12} post={post} />}
                    <UI.Text truncate>{post.hotelName}</UI.Text>
                  </UI.HorizontalLayout>
                )}
                color="white"
                transparent
                selected
                small
              />
            </div>
            <img
              onClick={onClickHandler(() => navigate(`/posts/${post.id}`))}
              key={post.id}
              src={post.id > 36
                ? URL.createObjectURL(images_db[post.images[0]]) // quick hack to load temporary images for the demo (like in PostImage.tsx)
                : `/hotels/${post.images[0]}`}
              alt={`Post ${post.id}`}
              style={{
                width: '100%',
                height: '100%',
                display: 'block',
                objectFit: 'cover',
              }}
            />
          </React.Fragment>
        )) }
      </UI.Grid>
    </UI.VerticalLayout>
  );
};

export default PostsGrid;
